<template >
    <div class="row" :data-expand="isExpand === true ? true : null">
        <div class="cells">
            <span class="cell">
                <div class="whitelist">
                    <span class="name">{{whiteList.titl}}</span><br>
                    <span class="desc">{{whiteList.desc}}</span>
                </div>
            </span>
            <span class="cell" data-size="status" data-align="center">
                <span class="txt-status" v-bind:data-status="whiteList.useCnt > 0 ? 'in-use' : null">
                    {{whiteList.useCnt > 0 ? $t('SETTING.WHITELIST.LABEL.ENABLED') : $t('SETTING.WHITELIST.LABEL.DISABLED')}}
                </span>
            </span>
            <span class="cell" data-size="date" data-align="center">
                <time datetime="">{{convertUtcTimezoneToLocal(whiteList.creaDt)}}</time>
            </span>
            <span class="cell" data-size="user" data-align="center">
                {{whiteList.creaUserNm}}
            </span>
            <span class="cell" data-size="date" data-align="center">
                <time datetime="">{{convertUtcTimezoneToLocal(whiteList.updtDt)}}</time>
            </span>
                <span class="cell" data-size="user" data-align="center">
                {{whiteList.updtUserNm}}
            </span>
            <span v-if="menuAuth == constants.AUTH_TYPE.EDIT" class="cell" data-size="console" data-align="center">
                <router-link v-bind:to="'/settings/whitelist/'+whiteList.wtlId" class="buttons-icon" data-type="line" data-size="s" data-icon="edit" :title="$t('SETTING.WHITELIST.LABEL.EDIT_TMPLT_TOOLTIP')">{{$t('COMMON.BUTTON.CAMEL.EDIT')}}</router-link>
                <button v-on:click="callDeleteWhitelist(whiteList)" type="button" class="buttons-icon" data-type="line" data-size="s" data-icon="delete" :title="$t('SETTING.WHITELIST.LABEL.DELETE_TMPLT_TOOLTIP')" data-trigger="delete-template">{{$t('COMMON.BUTTON.CAMEL.DELETE')}}</button>
            </span>
            <span class="cell" data-size="expand" data-align="center">
                <button type="button" class="buttons-icon" data-type="ghost" data-icon="expand" v-bind:data-expand="isExpand ? true : null" v-on:click="openWhitelistDetail()">collapse / expand</button>
            </span>
        </div>
        <!-- detail table -->
        <div-loading v-if="isExpand && isLoading"></div-loading>
        <div v-if="isExpand && !isLoading" class="expand-container">
            <div class="applied-resource">
                <h3 class="title"> {{ $t('SETTING.WHITELIST.LABEL.APPLIED_RESOURCE')}}</h3>
            </div>
            <div v-if="menuAuth == constants.AUTH_TYPE.EDIT" class="tbl-actions">
                <button v-on:click="openDialog(whiteList)"
                    type="button"
                    class="buttons"
                    data-type="line"
                    data-size="s"
                    data-icon="delete"
                    data-trigger="delete-resource"
                    :disabled="disableRmvRsrc">
                    {{ $t('SETTING.WHITELIST.BUTTON.DELETE_RESOURCE')}}
                </button>
            </div>
            <table class="tbl-inner">
                <caption></caption>
                <colgroup>
                    <col v-if="menuAuth == constants.AUTH_TYPE.EDIT" style="width: 34px;">
                </colgroup>
                <thead>
                <tr>
                    <th v-if="menuAuth == constants.AUTH_TYPE.EDIT" scope="row">
                        <input type="checkbox" name="select-all" class="checkbox txt-none"
                                v-bind:id="`related-rsrc-all-${whiteList.wtlId}`"
                                @change="clickDeleteResourceBoxAll(whiteList, $event)">

                        <label v-bind:for="`related-rsrc-all-${whiteList.wtlId}`">{{$t('LABEL.SELECT')}}</label>
                    </th>
                    <th scope="row">{{ $t('SETTING.WHITELIST.TABLE.VENDOR')}}</th>
                    <th scope="row">{{ $t('SETTING.WHITELIST.TABLE.ACCOUNT')}} </th>
                    <th scope="row">{{ $t('SETTING.WHITELIST.TABLE.PRODUCT')}}</th>

                    <!--<th scope="row">{{ $t('SETTING.WHITELIST.TABLE.SERVICEGROUP')}}</th>-->
                    <th scope="row">{{ $t('SETTING.WHITELIST.TABLE.TAG')}}</th>

                    <th scope="row">{{ $t('SETTING.WHITELIST.TABLE.REGION')}}</th>
                    <th scope="row">{{ $t('SETTING.WHITELIST.TABLE.RESOURCE')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(rsrc,idx) in whiteList.rsrcList" :key="idx">
                    <td v-if="menuAuth == constants.AUTH_TYPE.EDIT" class="txt-c">
                        <input type="checkbox" class="checkbox txt-none" :inst-id="rsrc.instId"
                                v-bind:id="`${whiteList.wtlId}-${idx}`" v-bind:name="'related-rsrc-'+whiteList.wtlId"
                                v-on:input="clickDeleteResourceBox(whiteList, idx, $event)"
                        >
                        <label :for="`${whiteList.wtlId}-${idx}`">{{$t('LABEL.SELECT')}}</label>
                    </td>
                    <td class="txt-c">
                        <span class="icon-vender txt-none" :data-vendor="getVendor(rsrc.vndr)" data-size="s" :title="rsrc.vndr">{{rsrc.vndr}}</span>
                    </td>
                    <td>{{rsrc.accId}}({{rsrc.accAlias}})</td>
                    <td>{{rsrc.rsrcType}}</td>
                    <td>{{rsrc.instNm}}</td>
                    <td>{{rsrc.rgnId}}</td>
                    <td>{{rsrc.instId}}</td>
                </tr>
                </tbody>
            </table>
            <Modal 
                v-if="isExpand"
                :okFunction="handleModalOkFunc"
                :title="modal.popupTitle"
                :message="modal.popupMessage"
                :isShowPopup="modal.isShowPopup"
                :callOnHide="handleHideModal"
                :btnOkStyle="modal.btnOkStyle"
                :isOKOnly="modal.isOKOnly"
            />
        </div>
    </div>
</template>

<script>
import Modal from "../../common/Modals/Modal.vue";
import {mapGetters} from "vuex";

export default {
    name: 'WhitelistCells',
    components: {
        Modal
    },
    props: {
        whiteList: {
            type: Object,
            default: {}
        },
        cmpnId: String,
        menuAuth: String | Object,
        callDeleteWhitelist: Function,
        callSelectWhitelistList: Function,
    },
    data() {
        return {
            isExpand: false,
            isLoading: false,
            disableRmvRsrc: true,
            modal: {
                isShowPopup: false
            },
        }
    },
    computed: {
        ...mapGetters({
            curCmpnId: 'user/curCmpnId'
        }),
    },
    methods: {
        getVendor(text) {
            if (text === 'azu') {
                return 'azure';
            }
            return text;
        },
        checkRsrcListAvailabe(isSelectAll) {
            if (isSelectAll) {
                this.disableRmvRsrc = !isSelectAll;
            } else {
                let tags = $(`input:checkbox[name=related-rsrc-${this.whiteList.wtlId}]:checked`);
                let rsrcList = [];
                _.forEach(tags, function(tag){
                    rsrcList.push({instId: tag.getAttribute('inst-id')});
                });
                this.disableRmvRsrc =  (rsrcList.length < 1);
            }
        },
        async deleteRsrc() {
            //Do you want to delete this resource from the whitelist?
            const url = "/api/governance/setting/whitelist/rsrc/delete";
            const header = this.modal.header;
            const selectedInstId = header.rsrcList.map(item => item.instId);
            let notRemoveList = [];
            this.whiteList.rsrcList.forEach(item => {
                if (selectedInstId.indexOf(item.instId) == -1) {
                    notRemoveList.push(item);
                }
            });
            header.rsrcList = notRemoveList;
            const response = await this.http.post(url, JSON.stringify(header));
            if (response.data.status === 'ok') {
                this.callSelectWhitelistList();
                this.isExpand = false;
                $('.table-row').removeClass('open');
                this.disableRmvRsrc = true;
            }
        },
        handleHideModal() {
            this.modal = {};
            this.modal.isShowPopup = false;
        },
        handleModalOkFunc() {
            if (this.modal.modalType === "rsrcList") {
                this.deleteRsrc();
            }
        },
        openDialog(wtl) {
            let modal = {};
            let tags = $(`input:checkbox[name=related-rsrc-${wtl.wtlId}]:checked`);
            let rsrcList = [];
            _.forEach(tags, function(tag){
                rsrcList.push({instId: tag.getAttribute('inst-id')});
            });
            if (rsrcList.length < 1) return;
            if(rsrcList.length >= wtl.rsrcList.length){
                modal = {
                    popupTitle: this.$t('SETTING.WHITELIST.POPUP.TITLE.DELETE_RESOURCE_ONE'),
                    popupMessage: this.$t('SETTING.WHITELIST.POPUP.DESC.DELETE_RESOURCE_ONE'),
                    isShowPopup: true,
                    isOKOnly: true,
                    modalType: "alert"
                }
            } else {
                // Do you want to delete this resource from the whitelist?
                const header = {
                    cmpnId: this.curCmpnId,
                    wtlId: wtl.wtlId,
                    rsrcList: rsrcList
                };
                modal = {
                    popupTitle: this.$t('SETTING.WHITELIST.POPUP.TITLE.DELETE_RESOURCE'),
                    popupMessage: this.$t('SETTING.WHITELIST.POPUP.DESC.DELETE_RESOURCE'),
                    isShowPopup: true,
                    modalType: "rsrcList",
                    btnOkStyle: "danger",
                    header
                }
            }
            this.modal = modal;
        },
        clickDeleteResourceBox(wtl, idx, $event){
            let checked = true;
            let tags = $(`input:checkbox[name=related-rsrc-${wtl.wtlId}]`);
            _.forEach(tags, function(tag){
                if(!tag.checked){
                    checked = false;
                }
            });

            $('#related-rsrc-all-'+wtl.wtlId).prop('checked', checked);
            $(event.target).prop('checked')
                ? $(`#${wtl.wtlId}-${idx}[name=related-rsrc-${wtl.wtlId}]`).closest("tr").addClass("selected")
                : $(`#${wtl.wtlId}-${idx}[name=related-rsrc-${wtl.wtlId}]`).closest("tr").removeClass("selected");
            this.checkRsrcListAvailabe();
        },
        clickDeleteResourceBoxAll(wtl, $event){
            $('[name="related-rsrc-'+wtl.wtlId+'"]').prop('checked',$event.target.checked);
            $event.target.checked
                ? $(`[name=related-rsrc-${wtl.wtlId}]`).closest("tr").addClass("selected")
                : $(`[name=related-rsrc-${wtl.wtlId}]`).closest("tr").removeClass("selected");
            this.checkRsrcListAvailabe($event.target.checked);
        },
        async openWhitelistDetail() {
            this.isLoading = true;
            this.isExpand = !this.isExpand;
            const url = "/api/governance/whielist/mapping/rsrc";
            const header = {
                "cmpnId": this.cmpnId,
                "wtlId": this.whiteList.wtlId
            };
            try {
                const response = await this.http.post(url, JSON.stringify(header));
                if(response.data.status === 'ok'){
                    this.whiteList.rsrcList = response.data.result.list;
                }
            } catch (err) {
                console.error(" ", err)
            } finally {
                this.isLoading = false;
            }
        },
        convertUtcTimezoneToLocal: function(date) {
            return date == null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale)
        },
    }
}
</script>

<style scoped>
.layout-contents button {
    border-radius: 4px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/settingComponents/WhitelistCells.vue